import createSvgIcon from "./utils/create_icon"

const LoadingCircle = createSvgIcon(<path d="M24 12c0 6.627-5.373 12-12 12v-2.4a9.6 9.6 0 0 0 9.6-9.6 9.6 9.6 0 0 0-19.2 0H0C0 5.373 5.373 0 12 0s12 5.373 12 12z" fill="currentColor" />, "LoadingCircle")
export default LoadingCircle
